// extracted by mini-css-extract-plugin
module.exports = {"headerBackground":"style_headerBackground__PGdtj","separator":"style_separator__pawo7","articleContainer":"style_articleContainer__EZFxW","body":"style_body__hjylJ"};